<template>
  <div class="box">
    <VText class="box__header" v-if="header">{{ header }}</VText>

    <router-link class="box__back" :to="backButtonTo" v-if="backButtonTo">
      <img src="@/assets/back-button.png" />
    </router-link>

    <div class="box__content">
      <slot />
    </div>
  </div>
</template>

<script>
import VText from '@/components/VText.vue';

export default {
  name: 'VBox',

  components: {
    VText,
  },

  props: {
    backButtonTo: {
      type: String,
    },

    header: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  position: relative;

  padding: 100px 45px 76px 57px;
  box-shadow: 2.9px 4px 43.3px 13.7px rgba(0, 0, 0, 0.36);
  background-color: #ffffff;

  &__header {
    position: absolute;
    top: 0;
    left: 50%;
    padding: 10px 20px;
    transform: translate(-50%, -50%) rotateZ(-3deg);

    text-transform: uppercase;
    background-color: #ffffff;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.36);
  }

  &__back {
    position: absolute;
    top: 0;
    left: 0;

    width: 50px;

    padding: 10px;
    transform: translate(-50%, -50%) rotateZ(2deg);

    background-color: #ffffff;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.36);

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
